import { render } from "./Group.vue?vue&type=template&id=002bba39&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"

import "./Group.vue?vue&type=style&index=0&id=002bba39&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-002bba39"

export default script